import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 重置样式
import 'normalize.css/normalize.css'
import '@/styles/common.css'
import 'element-plus/dist/index.css'

// mock
//require('./mock')
import '@/router/permission'
const app = createApp(App)
app.use(store).use(router).mount('#app')
